import findIndex from "lodash/findIndex";
import { SCHEDULE_TATKAL_REF_COMPONENTS } from "../constants/ScheduleTatkalTravelerPageConstants";
import { DOUBLE_DIGIT_DAY_WITH_MONTH_FORMAT, MAX_INFANT_ALLOWED } from "apps/rails/src/Utils/RailsConstant";
import { getHeaderTitleForTravelersAndReview } from "apps/rails/src/Utils/HeaderContentUtil";
import fecha from 'fecha';
import find from 'lodash/find';
import isEmpty from "lodash/isEmpty";
import { showShortToast } from "@mmt/legacy-commons/Common/Components/Toast";
import {
  getInfantCount,
} from '../../TravelerDetails/TravelerDetailsUtils';
import { _label } from 'apps/rails/src/vernacular/AppLanguage';
import {
  showHideIRCTCUsernameError,
  verifyTravelerDetails,
} from '../../TravelerDetails/TravelerDetailsActions';
import { isValidGstNumber } from '@mmt/legacy-commons/Helpers/validationHelpers';
import { getGenderfromValue } from '../../Constants/Gender';
import Traveler from '../../TravelerDetails/Components/Traveler';
import Berth, { getBerthType } from '../../Constants/Berth';
import Meal, { getMealObject } from '../../Constants/MealNew';
import { getQuota } from '../../Types/QuotaType';
import SrCitizenConcession from '../../Constants/SrCitizenConcession';
import { countries } from '../../Constants/Country';
import { getFormattedDate } from '@mmt/legacy-commons/Helpers/dateHelpers';

let scheduleTatkalRefs: any = [];
let _refs: any = [];
let _scrollPos = 0;

export const captureScheduleTatkalTravelerRef = (componentName: string, ref: any) => () => {
  if (Object.values(SCHEDULE_TATKAL_REF_COMPONENTS).includes(componentName)) {
    const reference = {
      component: componentName,
      ref,
    };

    const index = findIndex(scheduleTatkalRefs, (r: any) => r.component === reference.component);
    if (index !== -1) {
      scheduleTatkalRefs[index] = reference;
    } else {
      scheduleTatkalRefs = [...scheduleTatkalRefs, reference];
    }
    _refs = scheduleTatkalRefs;
  }
};

export const onScheduleTatkalPageScroll = (pos: any) => {
  _scrollPos = pos;
};

const scrollToBottom = (refs = _refs) => {
  const scrollComp = getComponentRef(refs, SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_SCHEDULE_TATKAL_PAGE_SCROLL_VIEW);
  const scrollRef = scrollComp ? scrollComp.ref : null;
  if (scrollRef) {
    scrollRef.scrollToEnd({animated: true});
  }
};

const getComponentRef = (refs: any, component: string) =>
  find(refs, (ref) => ref.component === component);

export const scrollToScheduleTatkalErrorComponent = (component: any, refs = scheduleTatkalRefs) => {
  try {
    
    const scrollComp = getComponentRef(refs, SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_SCHEDULE_TATKAL_PAGE_SCROLL_VIEW);
    const scrollRef = scrollComp ? scrollComp.ref : null;

    const comp = getComponentRef(refs, component) || getComponentRef(refs, SCHEDULE_TATKAL_REF_COMPONENTS.DUMMY_COMPONENT);
    const compRef = comp.ref;
    
    if (isEmpty(scrollRef)) {
      return ;
    }
    compRef.measure((tfx: any, tfy: any, twidth: any, theight: any, tpx: any, tpy: any) => {
      scrollRef.getNativeScrollRef().measure((fx: any, fy: any, width: any, height: any, px: any, py: any) => {
        scrollRef.scrollTo({ y: _scrollPos + tpy - py });
      });
    });
  } catch (error) {
    console.error(error)
  }
};

export const getScheduleTatkalHeaderTitle = (trainData: any) => {
  try {
    const titleText = getHeaderTitleForTravelersAndReview(trainData) || '';
    const subTitle = fecha.format(trainData?.departureDateAndTime, DOUBLE_DIGIT_DAY_WITH_MONTH_FORMAT) || '';
    return `${titleText} | ${subTitle}`;
  } catch (error) {
    return '';
  }
};

export const validateScheduleTatkalTravelerDetails = (state: any) => (dispatch: any) => {
  try {
    const {
      scheduleTatkalTraveler: {
        contactDetails = {},
        bkgCfg: { maxPassengers = 4 } = {}
      },
      railsUserVerification: { irctcUserName },
      railsTraveler: { gstDetails: {gstIn = '', nameOnGst = ''} = {}, optionalGstDetailsEnabled, selectedTravelers, warning, travelers },
    } = state || {};
    /* IRCTC username validation */
    if (!irctcUserName) {
        dispatch(showHideIRCTCUsernameError(true));
        scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_IRCTC_USERNAME);
        showShortToast(_label("enter_irctc_username"));
        return false;
      }
      /* IRCTC username validation */
    /* traveler validation */
    if (selectedTravelers.length > maxPassengers) {
      scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_TRAVELER);
      showShortToast(_label("irctc_max_traveller", undefined, {
        count: maxPassengers,
        quota: 'Tatkal'
      }));
      return false;
    }

    if (getInfantCount(selectedTravelers, travelers) > MAX_INFANT_ALLOWED) {
      scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_TRAVELER, scheduleTatkalRefs);
      showShortToast(_label("max_infants_allowed", undefined, { count: MAX_INFANT_ALLOWED }));
      return false;
    }

    if (warning?.showChildWithoutBerthWarning) {
      scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_TRAVELER);
      showShortToast(_label("irctc_child_berth_restriction"));
      return false;
    }

    if (!verifyTravelerDetails(selectedTravelers, travelers, maxPassengers, warning)) {
      scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_TRAVELER);
      showShortToast(_label("select_valid_traveller"));
      return false;
    }
    /* traveler validation */
    /* contact details validation */
    if (isEmpty(contactDetails) || !contactDetails?.hasCompleteFields) {
      scrollToScheduleTatkalErrorComponent(SCHEDULE_TATKAL_REF_COMPONENTS.COMPONENT_CONTACT_CARD);
      showShortToast(_label("fill_contact_details"));
      return false;
    }
    /* contact details validation */
    /* GST validation */
    const gstDetailsError =
      optionalGstDetailsEnabled &&
      (!isValidGstNumber(gstIn) || nameOnGst?.slice()?.trim()?.length === 0);
    if (gstDetailsError) {
      showShortToast(_label('fill_gst_details'));
      scrollToBottom();
      return false;
    }

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const convertFromEpochToHoursAndMinsFormat = (epoch: number) => {
  try {
    if (!epoch) {
      return '';
    }
    const date = new Date(epoch * 1000);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours}:${minutes}`;
  } catch (error) {
    return '';
  }
};

export const initServerTravelersMetaDataForScheduledTatkal = (
  travelers: any[] = [],
  config: any,
) => {
  try {
    const {
      applicableBerthTypes = [],
      foodChoiceEnabled = false,
      selectedQuota = getQuota('TQ'),
      classValue,
      seniorCitizenApplicable,
      applicableFoodTypes,
    } = config || {};
    const newTravelers = travelers?.map(
      (t, index) =>
        new Traveler(
          index,
          { firstName: t?.passengerName },
          t?.passengerAge,
          getGenderfromValue(t?.passengerGender),
          t?.childBerthFlag,
          applicableBerthTypes,
          foodChoiceEnabled,
          selectedQuota,
          classValue,
          true, //isSelected
          seniorCitizenApplicable,
          getBerthType(t?.passengerBerthChoice || Berth.NO_BERTH.key),
          applicableFoodTypes
            ? getMealObject(t?.passengerFoodChoice || Meal.NO.key, applicableFoodTypes)
            : undefined,
          SrCitizenConcession.FULL_CONCESSION,
          countries.IN,
          [Meal.NO.key],
          applicableFoodTypes,
          true,
        ),
    );
    return {
      travelers: newTravelers,
      selectedTravelers: newTravelers?.map((t) => t?.travelerId),
    };
  } catch (error) {
    console.log('Error in initServerTravelersMetaData for scheduled tatkal', error);
    return {
      travelers: [],
      selectedTravelers: [],
    };
  }
};

export const formatJourneyDate = (scheduleTatkalForm: any) => {
  try {
    const { doj } = scheduleTatkalForm?.journeyDetails || {};
    return doj ? getFormattedDate(doj, 'YYYYMMDD', 'D MMM') : ''; // Output format 'D MMM', e.g., '15 Oct'
  } catch (error) {
    return '';
  }
};

export const formatScheduleTatkalOpenTime = (tatkalWindowEpoch: any) => {
  try {
    if (!tatkalWindowEpoch) {
      return '';
    }

    const date = new Date(tatkalWindowEpoch * 1000);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedDate = getFormattedDate(date.toISOString(), 'YYYY-MM-DD', 'D MMM');

    return `${formattedHours}:${formattedMinutes} ${ampm}, ${formattedDate}`;
  } catch (error) {
    return '';
  }
};

export const formatDateTimeFromEpoch = (epoch: number) => {
  try {
    const date = new Date(epoch * 1000);
    const hours = date?.getHours();
    const minutes = date?.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedDate = getFormattedDate(date?.toISOString(), 'YYYY-MM-DD', 'D MMM');

    const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;

    return { formattedTime, formattedDate };
  } catch (error) {
    return { formattedTime: '', formattedDate: '' };
  }
};
